"use strict";

export function useBackButton(_) {
  // No-op
  // BackHandler is not available on web
}
//# sourceMappingURL=useBackButton.js.map